module.exports = __webpack_public_path__ + "static/media/2.0bc97b4f.png";